import { React, useState, useEffect } from 'react';
import Nav from './nav';
import './tabs.css';
import Certificate from './certificate';
import ItalianCertificate from './italianCertificate';
import app from './firebase';

function Tab() {
  const [activeTab, setActiveTab] = useState('Tab1');

  useEffect(() => {
    const titles = {
      Tab1: 'CIERHA - Certificate',
      Tab2: 'CIERHA - Italian Language Certificate',
    };
    document.title = titles[activeTab] || 'CIERHA - Admin';
  }, [activeTab]);

  return (
    <div className="CIERHA">
      <div className="tab-page">
        <Nav />
        <div className="tab-container">
          <div className="tabs">
            <button
              className={activeTab === 'Tab1' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab1')}
            >
              Certificate
            </button>
            <button
              className={activeTab === 'Tab2' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab2')}
            >
              Italian Language
            </button>
          </div>

          <div className="tab-content">
            {activeTab === 'Tab1' && (
              <div className="content">
                <Certificate app={app} />
              </div>
            )}
            {activeTab === 'Tab2' && (
              <div className="content">
                <ItalianCertificate app={app} />
              </div>
            )}
          </div>
        </div>
        <footer>G.A.P 2025 © All Rights Reserved.</footer>
      </div>
    </div>
  );
}

export default Tab;
